import { cva, type VariantProps } from '@veraclins-dev/cva';

import { styleProps } from './styles';

// Shared label behaviour (cursor, disabled/peer states) independent of the
// text treatment carried by `variant`.
const LABEL_BASE =
  'flex cursor-pointer items-center gap-2 select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50';

const labelVariants = cva({
  base: LABEL_BASE,
  responsive: {
    ...styleProps,
  },
  variants: {
    variant: {
      // Standard field label.
      default: 'text-sm/5 font-medium',
      // The label above a form field: smaller and in the muted text colour,
      // so the value the person types reads stronger than its label. The
      // muted text token holds 4.5:1 on the page, card and muted surfaces.
      field: 'text-xs/5 font-medium text-neutral-muted-foreground',
      // Uppercase eyebrow/caption used for field and section headers — the
      // recurring hand-rolled treatment, promoted to a first-class variant.
      caption:
        'text-xs leading-none font-semibold tracking-wider uppercase text-neutral-muted-foreground',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

type LabelVariants = VariantProps<typeof labelVariants>;

export { type LabelVariants, labelVariants };
